/** Variant-restriction I/O. These THROW rather than use the `useApi()` wrappers, which toast and
 *  return null — a resolved failure would let a generate run against restrictions never written. */
import type {
  PayloadPostMerchflowSaveVariantRestrictions,
  ResponsePostMerchflowSaveVariantRestrictions,
} from "@CommonApi/merchflow/save-variant-restrictions";
import { RoutePostMerchflowSaveVariantRestrictions } from "@CommonApi/merchflow/save-variant-restrictions";
import { API, postRequest } from "src/utils/axios";

export const saveVariantRestrictions = async (
  payload: PayloadPostMerchflowSaveVariantRestrictions,
): Promise<{ message: string }> => {
  const { data } = await postRequest<ResponsePostMerchflowSaveVariantRestrictions>(
    `${API}${RoutePostMerchflowSaveVariantRestrictions}`,
    { payload },
  );
  return { message: data.message };
};
